import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../../MainStyle.css';
import { API_ADD_ADDRESS, API_GET_ADDRESS_DETAILS, API_UPDATE_ADDRESS } from '../modals/Constants';
import { getStorage } from '../modals/Storage';
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import HeaderView from "../other-components/HeaderView/view";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import AlertDialog from "../dialogs/AlertDialog/dialog";

function UpdateAddress() {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const addressID = searchParams.get("id") || "";

    const [loading, setLoading] = useState(false);
    const [open, showDialogMessage] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");

    const [isPrimary, setPrimary] = useState(true);

    const [inMobileNum, setInMobileNum] = useState("");
    const [inFullName, setInFullName] = useState("");
    const [inPinCode, setPinCode] = useState("");
    const [inCity, setCity] = useState("");
    const [inState, setState] = useState("");
    const [inAreaLocality, setAreaLocality] = useState("");

    const showDialog = (status, msg) => {
        setDialogTitle(msg)
        showDialogMessage(status)
    }

    const getRecord = () => {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getStorage("accountSecret")}`,
                    },
                    body: JSON.stringify(formData),
                });

                const data = await res.json();
                const address = data.data[0];
                setLoading(false);

                if (data.status_code == "success") {
                    setInFullName(address.item_fullname)
                    setPinCode(address.item_pin_code)
                    setInMobileNum(address.item_mobile)
                    setCity(address.item_city)
                    setState(address.item_state)
                    setAreaLocality(address.item_area)
                }
            } catch (error) {
                setLoading(false);
                showDialog(true, "There was a technical issue! Please try again!");
            }
        };

        setLoading(true);
        const formData =
        {
            ACCOUNT_ID: getStorage("accountID"),
            ADDRESS_ID: addressID
        };
        requestAPI(API_GET_ADDRESS_DETAILS, formData);
    }

    const updateAddress = () => {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getStorage("accountSecret")}`,
                    },
                    body: JSON.stringify(formData),
                });

                const data = await res.json();
                setLoading(false);

                if (data.status_code == "success") {
                    navigate('/myaddress', { replace: true });
                } else {
                    showDialog(true, "There was a technical issue! Please try again!");
                }
            } catch (error) {
                setLoading(false);
                showDialog(true, "There was a technical issue! Please try again!");
            }
        };

        if (inMobileNum != "" && inFullName != "" && inPinCode && inCity != "" && inState != "" && inAreaLocality != "") {
            setLoading(true);
            const formData =
            {
                ACCOUNT_ID: getStorage("accountID"),
                ADDRESS_ID: addressID,
                ADDRESS_FULLNAME: inFullName,
                ADDRESS_MOBILE: inMobileNum,
                ADDRESS_PINCODE: inPinCode,
                ADDRESS_CITY: inCity,
                ADDRESS_STATE: inState,
                ADDRESS_AREA: inAreaLocality,
                ADDRESS_PRIMARY: isPrimary
            };
            requestAPI(API_UPDATE_ADDRESS, formData);
        }
    }

    useEffect(() => {
        if (getStorage("accountID") == '' || getStorage("accountSecret") == '') {
            navigate('/signin', { replace: true });
        }
    }, [inFullName, inMobileNum, inPinCode, inCity, inState, inAreaLocality]);

    useEffect(() => {
        getRecord();
    }, []);

    return (
        <div className={[general.appView]}>
            <LoadingDialog isOpen={loading} />

            <AlertDialog
                isOpen={open}
                title={dialogTitle}
                onClose={() => showDialogMessage(false)}
                actions={[
                    { label: "Close", variant: "neutral", onClick: () => showDialogMessage(false) }
                ]}
            />

            <div className={[general.appChildView]}>
                <HeaderView />

                <div className={general.appLocationViews}>
                    <p>Update Address</p>
                </div>

                <div className={[general.appContentsView]}>
                    <div className={[screen.profileView].join(" ")}>
                        <div>
                            <span className='ft-sz-13'>Full Name</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inFullName} onChange={e => setInFullName(e.target.value)}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Mobile</span>
                            <div className={general.inpBoxOutline}>
                                <input type="number" autoComplete="new-password" value={inMobileNum} onChange={e => setInMobileNum(e.target.value)}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>PIN Code/ZIP Code*</span>
                            <div className={general.inpBoxOutline}>
                                <input type="number" autoComplete="new-password" value={inPinCode} onChange={e => setPinCode(e.target.value)}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>City</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inCity} onChange={e => setCity(e.target.value)}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>State</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inState} onChange={e => setState(e.target.value)}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Area/Locality</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inAreaLocality} onChange={e => setAreaLocality(e.target.value)}></input>
                            </div>
                        </div>
                    </div>

                    <div className={general.rowView} onClick={() => setPrimary(!isPrimary)}>
                        <div className={[general.radioBtn, isPrimary ? general.active : null].join(" ")}></div>
                        <p className={general.mgL10px}>Is this primary address?</p>
                    </div>

                    <button className={[general.primaryBtn, general.mgT25px, general.rounded1x].join(" ")} onClick={() => updateAddress()}>Update Address</button>
                </div>
            </div>
        </div>
    );
}

export default UpdateAddress;